module.exports = __webpack_public_path__ + "img/image_10.2148397c.png";